var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSummaryFeatureGroupCheckIcon = function SvgSummaryFeatureGroupCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#D7E7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6446 11.0855L14.9046 21.4505L12.0546 18.4055C11.5296 17.9105 10.7046 17.8805 10.1046 18.3005C9.51963 18.7355 9.35463 19.5005 9.71463 20.1155L13.0896 25.6055C13.4196 26.1155 13.9896 26.4305 14.6346 26.4305C15.2496 26.4305 15.8346 26.1155 16.1646 25.6055C16.7046 24.9005 27.0096 12.6155 27.0096 12.6155C28.3596 11.2355 26.7246 10.0205 25.6446 11.0705V11.0855Z",
    fill: "#2B81FC"
  })));
};
export default SvgSummaryFeatureGroupCheckIcon;